"use strict"

import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import moment from "moment"
import fields from "./waitingFields"
import validatorjs from "validatorjs"
import MobxReactForm from "mobx-react-form"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import {Container, Box, Grid, Typography} from "@material-ui/core"
import XsTable from "../../global/ui/xsTable/xsTable"
import WaitingStore from "./waitingStore"
import GlobalStore from "../../global/store/GlobalStore"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"
import XsIconButton from "../../global/ui/xsButton/xsIconButton"
import XsButton from "../../global/ui/xsButton/xsButton"

const columns = [
	{
		Header: "Poradové číslo",
		width: 50,
		accessor: "sequence"
	},
	{
		Header: "Číslo žiadosti",
		width: 80,
		accessor: "request_number"
	},
	{
		Header: "Dátum prijatia žiadosti",
		width: 100,
		accessor: "sent_date_time",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Zariadenie",
		width: 120,
		accessor: "device_name"
	},
	{
		Header: "Stav žiadosti",
		width: 90,
		accessor: "status_name_ext"
	},
	{
		Header: "Predpokladaná hodnota (EUR)",
		width: 100,
		accessor: "expected_voucher_amount"
	},
	{
		Header: "Výška príspevku (EUR)",
		width: 100,
		accessor: "paid_voucher"
	}
]

function WaitingList() {
	const hooks = {
		onSubmit() {},
		onSuccess(form) {
			WaitingStore.getWaitingList(form)
		},
		onError() {
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [form] = useState(new MobxReactForm(fields.load(), {plugins: {dvr: dvr(validatorjs)}, hooks}))

	useEffect(() => {
		// WaitingStore.getWaitingList(form)
		WaitingStore.loadRounds()
		WaitingStore.getFilterDevices()
	}, [])

	return (
		<Container maxWidth="lg">
			<Grid container justify="space-between" alignItems="center" className="mt-8">
				<Grid item>
					<Typography variant="h4">Poradovník žiadostí</Typography>
				</Grid>
			</Grid>
			<Box pt={2}>
				<Grid container alignItems="center" spacing={2} className="mb-4">
					<Grid item>
						<Typography variant="body2" style={{fontWeight: "bold", color: "#c10b25"}}>
							Pre zobrazenie poradovníka žiadostí je potrebné najskôr zvoliť kolo výzvy
						</Typography>
					</Grid>
					<Grid item style={{minWidth: 250, flex: 1}}>
						<XsSearchSelect field={form.$("round_id")} items={WaitingStore.recordRounds} />
					</Grid>
					<Grid item>
						<XsButton
							className="xs-primary"
							disabled={isEmpty(form.$("round_id").value)}
							text="Načítať žiadosti"
							onClick={form.onSubmit}
						/>
					</Grid>
				</Grid>
				<Grid container alignItems="center" style={{gap: 8}}>
					<Grid item>
						<Typography variant="caption" style={{fontWeight: "bold"}}>
							Vyhľadať v existujúcich záznamoch:
						</Typography>
					</Grid>
					<Grid item style={{flex: 1}}>
						<div style={{height: 1, backgroundColor: "#CED7D9", width: "100%"}}></div>
					</Grid>
				</Grid>
				<Grid container alignItems="center" style={{gap: 8}} className="mt-3 mb-3">
					<Grid item xs={2}>
						<XsInput field={form.$("request_number")} />
					</Grid>
					<Grid item xs={2}>
						<XsSearchSelect field={form.$("device")} items={WaitingStore.filterDevices} />
					</Grid>
					<Grid item xs={2}>
						<XsSearchSelect field={form.$("request_state")} items={WaitingStore.requestStatus} />
					</Grid>
					<Grid item>
						<XsIconButton
							rect
							className="xs-default xs-outline fa-pull-right"
							tooltip={"Aplikovať filtre"}
							disabled={isEmpty(form.$("round_id").value)}
							onClick={form.onSubmit}
							icon={
								<i
									className="far fa-search fa-lg xs-greyDefault"
									style={{paddingTop: "8px", paddingBottom: "8px", paddingLeft: "1px", paddingRight: "1px"}}
								></i>
							}
						/>
						<XsIconButton
							rect
							className="xs-default xs-outline fa-pull-right mr-1"
							disabled={isEmpty(form.$("round_id").value)}
							tooltip={"Resetovať filtre"}
							variant="outlined"
							color="primary"
							onClick={(e) => {
								form.$("request_number").value = null
								form.$("device").value = null
								form.$("request_state").value = null
								form.onSubmit(e)
							}}
							icon={
								<i
									className="far fa-times fa-lg xs-greyDefault"
									style={{paddingTop: "9px", paddingBottom: "9px", paddingLeft: "4px", paddingRight: "4px"}}
								></i>
							}
						/>
					</Grid>
				</Grid>
				<Grid container>
					<Grid item xs={12}>
						<Box pt={1}>
							<XsTable columns={columns} data={WaitingStore.data} />
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Container>
	)
}

export default injectIntl(observer(WaitingList))

